/**
 * Date-extensions locale Italian [it]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('it', {
    monthNames: ['Gennaio','Febbraio','Marzo','Aprile','Maggio','Giugno','Luglio','Agosto','Settembre','Ottobre','Novembre','Dicembre'],
    monthShortNames: ['Gen','Feb','Mar','Apr','Mag','Giu','Lug','Ago','Set','Ott','Nov','Dic'],
    dayNames: ['Domenica','Lunedì','Martedì','Mercoledì','Giovedì','Venerdì','Sabato'],
    dayShortNames: ['Dom','Lun','Mar','Mer','Gio','Ven','Sab']
});
